import { useSelector } from 'react-redux';
import { allContentSelector } from '../features/apiFeatures/contentSlice';
import { allContentTypesSelector } from '../features/apiFeatures/contentTypeSlice';
import { allFieldsSelector } from '../features/apiFeatures/fieldSlice';
import { allFieldTypesSelector } from '../features/apiFeatures/fieldTypeSlice';
import { allHearingRolesSelector } from '../features/apiFeatures/hearingRoleSlice';
import { allHearingStatusSelector } from '../features/apiFeatures/hearingStatusSlice';
import { allHearingTypesSelector } from '../features/apiFeatures/hearingTypeSlice';
import { allSubjectAreasSelector } from '../features/apiFeatures/subjectAreaSlice';
import { allUserHearingRolesSelector } from '../features/apiFeatures/userHearingRoleSlice';
import { allUsersSelector } from '../features/apiFeatures/userSlice';
import { baseApiUrlSelector } from '../features/bootstrapSlice';
import { comparators } from './comparators';
import { filterAndSortingKeys } from './filterAndSortingsUtil';
import { filterHearingItems } from './filterHearingItems';
import { mapHearingItem } from './mapHearingItem';
import { paginateItems } from '../app/agora/routes/pagination/paginateItems';
import { paginatedHearingsSelector } from '../features/componentFeatures/hearingOverviewSlice';
import { useTranslation } from 'react-i18next';
import { allCityAreasSelector } from '../features/apiFeatures/cityAreaSlice';

export function GetHearingsToRender(usingPagination, hearings, filterKeys) {
  const { t: translator } = useTranslation();
  const hearingStatuses = useSelector(allHearingStatusSelector);
  const hearingTypes = useSelector(allHearingTypesSelector);
  const subjectAreas = useSelector(allSubjectAreasSelector);
  const cityAreas = useSelector(allCityAreasSelector);
  const fieldTypes = useSelector(allFieldTypesSelector);
  const fields = useSelector(allFieldsSelector);
  const contents = useSelector(allContentSelector);
  const userHearingRoles = useSelector(allUserHearingRolesSelector);
  const users = useSelector(allUsersSelector);
  const hearingRoles = useSelector(allHearingRolesSelector);
  const baseApiUrl = useSelector(baseApiUrlSelector);
  const contentTypes = useSelector(allContentTypesSelector);
  const hearingIdsForPage = useSelector(paginatedHearingsSelector);

  var filteredHearings;

  if (usingPagination) {
    filteredHearings = paginateItems(hearings, hearingIdsForPage);
  } else {
    filteredHearings = hearings.filter(
      filterHearingItems(
        filterKeys,
        contents,
        fieldTypes,
        fields,
        hearingRoles,
        userHearingRoles,
        users,
      ),
    );
  }

  const itemsToRender = filteredHearings.map((h) =>
    mapHearingItem(
      h,
      subjectAreas,
      cityAreas,
      hearingTypes,
      hearingStatuses,
      fieldTypes,
      fields,
      contents,
      users,
      userHearingRoles,
      hearingRoles,
      baseApiUrl,
      contentTypes,
      translator('hearingProperties.defaultHearingTitle'),
    ),
  );

  const sortedItemsToRender = !!comparators.hearingOverview[
    filterKeys[filterAndSortingKeys.sortingKey]
  ]
    ? itemsToRender.sort(
        comparators.hearingOverview[
          filterKeys[filterAndSortingKeys.sortingKey]
        ],
      )
    : itemsToRender;

  return sortedItemsToRender;
}
